import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const LoaderContainer = styled.div`
    display: grid;
    -ms-grid-columns: 100vw;
    grid-template-columns: 100vw;
    -ms-grid-rows: 100vh;
    grid-template-rows: 100vh;
    position: absolute;
    left: 0px;
    top: 0px;
    background: rgba(0,0,0,.2);
    z-index:2;
`

const LoaderAnimationContainer = styled.div`
    align-self: center;
    justify-self: center;  
    text-align: center;
`;

const LoaderText = styled.h1`
    font-size:2em;
    color: #666666;
    -webkit-user-select: none;         
    -moz-user-select: none; 
    -ms-user-select: none; 
    user-select: none;  
`;

const LoaderAnimationRing = styled.div`
    display: inline-block;
    position: relative;
    width: 64px;
    height: 64px;

    div {
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: 51px;
        height: 51px;
        margin: 6px;
        border: 6px solid #F7510C;
        border-radius: 50%;
        animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: #F7510C transparent transparent transparent;        
    }

    div:nth-child(1) {
        animation-delay: -0.45s;
    }

    div:nth-child(2) {
        animation-delay: -0.3s;
    }
    
    div:nth-child(3) {
        animation-delay: -0.15s;
    }    

    @keyframes lds-ring {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }    
`


//using stateless functional component for loading animation
//this is just a dumb component which renders a loading spinner
//whether or not to show it or not is handled in the parent component
const LoaderAnimation = ({ loadingText }) => {
    return (
        <LoaderContainer>
            <LoaderAnimationContainer>
                <LoaderText>{loadingText}</LoaderText>
                <LoaderAnimationRing>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </LoaderAnimationRing>            
            </LoaderAnimationContainer>
        </LoaderContainer>
    )
}

LoaderAnimation.propTypes = {
    loadingText: PropTypes.string,
}

export default LoaderAnimation;


// WEBPACK FOOTER //
// ./src/components/shared/loaderAnimation.js